import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getAllowedIntegrations = () => {
    return axiosPrivate.get(`/dashboard/api/v1/integrationsv1/allowed-integrations`);
};
